import { render, staticRenderFns } from "./FactorCodeMng.vue?vue&type=template&id=0a0bb7ac"
import script from "./FactorCodeMng.vue?vue&type=script&lang=js"
export * from "./FactorCodeMng.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a0bb7ac')) {
      api.createRecord('0a0bb7ac', component.options)
    } else {
      api.reload('0a0bb7ac', component.options)
    }
    module.hot.accept("./FactorCodeMng.vue?vue&type=template&id=0a0bb7ac", function () {
      api.rerender('0a0bb7ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/cp/FactorCodeMng.vue"
export default component.exports